import React from 'react'
import { csx } from '@vtex/admin-ui'

import { DetailedProductsList, PartnerStoreTag } from '../../../../components'
import type { ShippingMethod } from '../../../../constants/shipping'
import type { Package } from '../../../../../../core/typings'
import { PackageTitle } from './PackageTitle'
import { ShippingPackageItem } from './ShippingPackageItem'
import { PackageDivider } from './PackageDivider'
import { PackageDetailsBlock } from './PackageDetailsBlock'
import { getCartItemReactKey } from '../../../../utils'
import { groupItemsWithAssemblyItems } from '../../../Cart/utils/groupItemsWithAssemblyItems'

export type ShippingPackageProps = {
  currentPackage: Package
  packageNumber: number
  selectedShippingMethod: ShippingMethod
  onItemSlaChange: () => void
}

export const ShippingPackage = ({
  currentPackage,
  packageNumber,
  selectedShippingMethod,
  onItemSlaChange,
  ...props
}: ShippingPackageProps) => {
  const items = groupItemsWithAssemblyItems(currentPackage.items)

  return (
    <div {...props}>
      <PackageDivider />
      <div className={csx({ paddingY: '$space-2' })}>
        <div
          className={csx({ justifyContent: 'space-between', display: 'flex' })}
        >
          <PackageTitle packageNumber={packageNumber} />
          <PartnerStoreTag sellerId={currentPackage.seller} />
        </div>
        <PackageDetailsBlock currentPackage={currentPackage} />
        <DetailedProductsList className={csx({ marginTop: '$space-4' })}>
          {items.map((item) => (
            <ShippingPackageItem
              key={getCartItemReactKey(
                item.orderFormItem.item.id,
                item.orderFormItem.index
              )}
              data-testid="shipping-package-item"
              currentPackage={currentPackage}
              selectedShippingMethod={selectedShippingMethod}
              onItemSlaChange={onItemSlaChange}
              item={item}
            />
          ))}
        </DetailedProductsList>
      </div>
    </div>
  )
}
